<template>
    <UiModal ref="modal" v-model:display="display" :title="t('Log out')" static @key="onModalKey">
        <p>{{ t("Do you want to log out of the application?") }}</p>
        <template #footer>
            <UiButton variant="secondary" @click="close">{{ t("Cancel") }}</UiButton>
            <UiButton icon="fas fa-sign-out-alt" @click="logout">{{ t("Log out") }}</UiButton>
        </template>
    </UiModal>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { AuthController } from "@/control/auth";
import { useModalClose } from "@/composables/useModal";
import { useTemplateRef } from "vue";
import UiModal from "@/components/utils/UiModal.vue";
import UiButton from "@/components/utils/UiButton.vue";
import { handleModalConfirmKey } from "@/utils/form-keyboard";

defineOptions({ name: "LogoutModal" });

const display = defineModel<boolean>("display");
const modal = useTemplateRef("modal");
const close = useModalClose(modal);
const router = useRouter();

const logout = () => {
    close();
    AuthController.Logout().then(() => {
        router.push({ name: "login" });
    });
};

const onModalKey = (e: KeyboardEvent) => {
    handleModalConfirmKey(e, logout);
};
</script>

<style></style>
